/* eslint-disable import/prefer-default-export */
import { MutationHookOptions } from '@apollo/client'
import { useCallback } from 'react'

import {
  CountTestimonialsDocument,
  PaginatedTestimonialsDocument,
  useDeleteTestimonialMutation,
} from '~generated/hooks'
import { DeleteTestimonialMutation, DeleteTestimonialMutationVariables } from '~generated/operations'
import { testimonialObjTypename } from '~lib/apollo/typenames'

export function useDeleteTestimonial(
  baseOptions?: MutationHookOptions<DeleteTestimonialMutation, DeleteTestimonialMutationVariables>
) {
  const [deleteTestimonialMutation, options] = useDeleteTestimonialMutation(baseOptions)

  const deleteTestimonial = useCallback(
    (id: string) => {
      deleteTestimonialMutation({
        refetchQueries: [CountTestimonialsDocument, PaginatedTestimonialsDocument],
        awaitRefetchQueries: true,
        variables: { id },
        update: (cache) => {
          cache.evict({ id: cache.identify({ id, __typename: testimonialObjTypename }) })
          cache.gc()
        },
      })
    },
    [deleteTestimonialMutation]
  )

  return [deleteTestimonial, options] as const
}
